<style lang="sass" scoped>
.wrapper
  margin-top: 150px
  text-align: center
  h1
    margin-bottom: 10px
    font-size: 40px
    line-height: 1.1em
  p
    margin-top: 15px
    margin-bottom: 15px
    font-size: 16px
    line-height: 1.1em
</style>

<template lang="pug">
.wrapper
  h1 404
  p 当前页面不存在
  sms_button(url="/", link) 回到首页
  p {{ countdown }} S 后返回首页
</template>

<script>
export default {
  data () {
    return {
      countdown: 5
    }
  },
  mounted () {
    setInterval(() => {
      this.countdown --
    }, 1000);
  },
  watch: {
    countdown: function () {
      if (this.countdown === 0) {
        this.$router.push('/dashboard');
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// NotFound.vue?3368143d